import { render, staticRenderFns } from "./ProjContent.vue?vue&type=template&id=2484250f&"
import script from "./ProjContent.vue?vue&type=script&lang=js&"
export * from "./ProjContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports